import React from 'react';


const Notification = () => (<div style={{marginBottom: 20}}>  </div>);
export default Notification;



// WEBPACK FOOTER //
// ./src/components/page/Notification/container/index.js